interface Properties {
  width?: number;
  height?: number;
}

const DimensionsIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_684_1037)'>
        <path
          d='M22.8926 26.2132L6.28827 17.1893C5.54969 16.7881 4.67751 16.8046 3.95478 17.2343C3.23204 17.6638 2.80078 18.4222 2.80078 19.263V40.1964C2.80078 41.0434 3.25815 41.8296 3.9945 42.2483L20.5992 51.688C20.9652 51.8961 21.3655 52 21.7659 52C22.1739 52 22.5818 51.892 22.9527 51.6761C23.6873 51.2487 24.1259 50.4861 24.1259 49.6361V28.287C24.1259 27.4213 23.6535 26.6266 22.8926 26.2132Z'
          fill='currentColor'
        />
        <path
          d='M46.1863 11.7442C46.1852 10.8603 45.6969 10.0587 44.9123 9.65197L26.8058 0.264877C26.1202 -0.0906987 25.3031 -0.0880573 24.6201 0.271481L6.77987 9.65858C6.00309 10.0675 5.51992 10.8667 5.5188 11.7446C5.51778 12.6223 5.99903 13.4226 6.77469 13.8332L24.615 23.279C24.9605 23.4617 25.3397 23.5532 25.7192 23.5532C26.0939 23.5532 26.4688 23.464 26.8108 23.2855L44.9177 13.8399C45.7014 13.4311 46.1875 12.628 46.1863 11.7442Z'
          fill='currentColor'
        />
        <path
          d='M48.0454 17.2343C47.323 16.8047 46.4505 16.7877 45.7122 17.1892L29.1073 26.2132C28.3467 26.6267 27.8743 27.4213 27.8743 28.2869V49.636C27.8743 50.486 28.3128 51.2487 29.0475 51.6761C29.4184 51.892 29.8262 51.9999 30.2343 51.9999C30.6346 51.9999 31.035 51.8959 31.401 51.688L48.0057 42.2483C48.7421 41.8296 49.1994 41.0434 49.1994 40.1964V19.263C49.1994 18.4222 48.7681 17.6639 48.0454 17.2343Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_684_1037'>
          <rect width='52' height='52' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DimensionsIconActive;
